<template>
  <section class="quotewizard">
    <loader :loading="loading"></loader>
    <div class="container purchasesummary-end">
      <br /><br /><br />
      <div class="title" style="text-align: center; color: #333">
        Something went wrong.
      </div>
      <p style="text-align: center; margin-top: 4px; line-height: 22px">
        Please try again.
      </p>
      <br /><br />
      <table
        width="100%"
        style="max-width: 600px"
        border="0"
        cellspacing="0"
        cellpadding="0"
        class="mobilecollpasetable"
        align="center"
      >
        <tbody>
          <tr>
            <td valign="top" class="error">
              <table width="100%" border="0" cellspacing="0" cellpadding="0">
                <tbody>
                  <tr>
                    <td width="20%" valign="top">
                      <span class="bigerror-x"></span>
                    </td>
                    <td valign="top">
                      <strong>Your Renters Insurance</strong>
                      <div class="try">
                        Things you can try...<br />
                        <ul>
                          <li>
                            <a href="#" @click="retryIssuePolicy">Retry</a>
                            transaction <br />
                          </li>
                          <li>
                            <a
                              href="https://www.nssi.com/contact-us"
                              target="_blank"
                            >
                              Contact NSSI
                            </a>
                            for help or to report an issue<br />
                          </li>
                        </ul>
                      </div>
                      <b>Failed! You're <u>NOT</u> Covered.</b><br />
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <br />
      <hr />
      <br /><br />
      <p style="text-align: center; line-height: 22px">
        <router-link :to="{ name: 'home' }" @click="quoteDone()"
          >Return to homepage</router-link
        >
      </p>
    </div>
  </section>
</template>

<script lang="ts" setup>
import { NssiData } from "@/api/NssiData";
import Loader from "@/components/MainLoader.vue";
import { AssurantData } from "@/api/AssurantData";
import { ref } from "vue";
import { useQuoteStore } from "@/stores/root/quote";
import { useUserStore } from "@/stores/root/users";

const loading = ref(false);
const quote = useQuoteStore();
const userStore = useUserStore();
const user = userStore.user;

const getId = async () => {
  try {
    const cartId = await NssiData.toRemote(quote);
    return cartId;
  } catch (error) {
    console.log(error);
  }
};

const retryIssuePolicy = async () => {
  loading.value = true;

  if (quote.rentersInsurance && !quote.assurantPassed) {
    const result = await AssurantData.issuePolicy(quote);
    if (result.error) {
      quote.assurantPassed = false;
      quote.assurantPolicyError = result.message;
      loading.value = false;
      quote.setQuoteStep("quote-done-assurant-failed-api");
      return;
    } else {
      quote.assurantPassed = true;
      quote.rentersInsurance.policyNumber =
        result.result.transactionDetails.policyId;
      quote.assurantPolicyError = "";
    }
  }

  if (quote.personalInsurance && !quote.nssiPassed) {
    const result = await NssiData.issuePolicy(quote, user, getId);

    if (result.error) {
      quote.nssiPassed = false;
      quote.nssiPolicyError = result.message;
      loading.value = false;
      quote.setQuoteStep("quote-done-nssi-failed-api");
      return;
    } else {
      quote.nssiPassed = true;
      //quote.personalInsurance.orderId = result.policy.PolicyID;
      quote.personalInsurance.policyNumber = result.policy;
      quote.nssiPolicyError = "";
    }
  }

  loading.value = false;
  quote.setQuoteStep("quote-done");
};

function quoteDone() {
  quote.done = true;
}
</script>
